module.exports = __webpack_public_path__ + "img/DSCU.a91cf2df.png";